import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormErrorMessageModule } from "src/app/kernel/form/modules/tools/form-error-message/form-error-message.module";
import {DropdownModule} from "primeng/dropdown";
import { MultiSelectModule } from "primeng/multiselect";
import {TranslateModule} from "@ngx-translate/core";
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AutocompleteComponent } from './componenets/autocomplete/autocomplete.component';

@NgModule({
    declarations: [AutocompleteComponent],
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      FormErrorMessageModule,
      DropdownModule,
      MultiSelectModule,
      TranslateModule,
      AutoCompleteModule
    ],
    exports: [
      AutocompleteComponent,
      FormsModule,
      ReactiveFormsModule,
    ]
})

export class AutocompleteModule {

}
